module.exports = __webpack_public_path__ + "static/media/step1.f29d9605.png";